import React from 'react'
import { FaArrowRight } from "react-icons/fa";
import HeroImage from "../assets/heroImage.jpg"
import { Link } from 'react-scroll'

const Home = () => {
    return (

        <div
            name="home"
            className=' h-screen w-full bg-gradient-to-b from-black via-black to-gray-800'
        >

            <div className='max-w-screen-lg mx-auto flex flex-col 
        items-center justify-center h-full px-4 md:flex-row'>

                <div className='flex flex-col justify-center h-full'>

                    <h2 className=' text-4xl sm:text-7xl pt-14 font-bold text-gray-400 animate-pulse' > 
                    I'm a FrontEnd Developer</h2>


                    <p className='text-gray-500 py-4 max-w-md'>
                        Hello there!
                        I'm Omkar Uttam Bate, and I'm a B Tech. Information Technology engineering student at G H Raisoni Institute of Engineering and Technology in Pune. I dabble in a variety of technologies, trying everything and learning as much as possible. My main interests are Frontend Development , and I'm looking forward to pursuing a career in these fields.
                        Always eager to meet new people and explore new opportunities.


                    </p>
                    <div>
                        <Link to="portfolio" smooth duration={500} className='group text-white w-fit px-6 py-3 my-2 flex items-center rounded-md bg-gradient-to-r from-cyan-500 to-blue-500  cursor-pointer ' >
                            Portfolio
                            <span className='group-hover:rotate-90 duration-300'>

                                <FaArrowRight size={20} />
                            </span>
                        </Link>
                    </div>
                </div>
                <div>
                    <img
                        src={HeroImage}
                        alt="my profile" className='rounded-2xl mx-auto w-2/3 md:w-full'
                    />
                </div>
            </div>

        </div>
    );
};

export default Home

